<template>
<div class=''>没有找到相关页面，请添加</div>
</template>

<script>
export default {
components: {},
data() {
return {

};
},
computed: {},
watch: {},
methods: {},
created() {},
mounted() {},
beforeCreate() {},
beforeMount() {},
beforeUpdate() {},
updated() {},
beforeDestroy() {},
destroyed() {},
activated() {},
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components-frame/not-found.vue